export const filterStraddleHistoryData = (
    filters,
    fyersStraddleHistoryData,
    setFilteredFyersStraddleHistoryData
) => {
  const filteredData = [...fyersStraddleHistoryData].filter(
    (trade) => {
      // Check if the filters object is empty
      if (Object.keys(filters).length === 0) {
        return true; // No filters, include all trades
      }

      return Object.entries(filters).every(([key, value]) => {
        if (value === "") {
          return true; // If the filter value is empty, include the trade
        }

        // Case-insensitive string matching for other fields
        return String(trade[key])
          .toLowerCase()
          .includes(String(value).toLowerCase());
      });
    }
  );

  setFilteredFyersStraddleHistoryData(filteredData);
};
